import { render, staticRenderFns } from "./btnTab.vue?vue&type=template&id=baa7f406&"
import script from "./btnTab.vue?vue&type=script&lang=js&"
export * from "./btnTab.vue?vue&type=script&lang=js&"
import style0 from "./btnTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports